<template>
  <div class="FindRetailerQuickBox bg-bg-secondary p-12">
    <div class="type-headline-base mb-2">{{ $t('findRetailer.quickbox.headline') }}</div>
    <div class="mb-12 text-text-subtle">{{ $t('findRetailer.quickbox.text') }}</div>

    <div class="relative">
      <input
        v-model="searchterm"
        type="text"
        :placeholder="$t('findRetailer.searchPlaceholder')"
        class="w-full h-48 border border-border-base pl-12 mobOnly:type-sm"
        @keydown.enter="doSearch"
      >
      <button
        class="btn !absolute h-40 px-16 type-headline-sm right-4 top-4"
        type="button"
        @click="doSearch"
      >
        {{ $t('findRetailer.findbutton') }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalContentStore } from '~/store/globalContent';
const searchterm = ref('');
const globalContent = useGlobalContentStore();
const { $sbLinkFix } = useNuxtApp();

const doSearch = () => {
  const toLink = $sbLinkFix(globalContent.config?.findRetailerPage);

  navigateTo(`${toLink}?search=${searchterm.value}`);
};
</script>
